import React from "react";
import { useData } from "./contexts";

function Footer(props) {
  const { data } = useData();

  return (
    <div className="section-footer text-center">
      <div className="wrapper container">
        <p className="display-8 py-2">Designed & Developed by <a href="https://github.com/gauravk268">Gaurav Kumar</a> & <a href={data.links.github}>{data.name}</a></p>
        <div className="icons px-5">
          <a
            className="footer-icon linkedin"
            href={data.links.linkedin}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="linkdedin logo" src="/assets/icons/linkedin.svg" />
          </a>

          <a
            className="footer-icon github"
            href={data.links.github}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="github logo" src="/assets/icons/github.svg" />
          </a>

          <a
            className="footer-icon twitter"
            href={data.links.twitter}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="twitter logo" src="/assets/icons/twitter.svg" />
          </a>

          <a
            className="footer-icon instagram"
            href={data.links.instagram}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="instagram logo" src="/assets/icons/instagram.svg" />
          </a>

          <a
            className="footer-icon codeforces"
            href={data.links.codeforces}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="codeforces logo" src="/assets/icons/codeforces.svg" />
          </a>

          <a
            className="footer-icon kaggle"
            href={data.links.kaggle}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="kaggle logo" src="/assets/icons/kaggle.svg" />
          </a>

        </div>
      </div>
    </div>
  );
}

export default Footer;
